import vscode from "../assets/svg/tools/vscode.svg";
import itj from "../assets/svg/tools/intellij-idea.svg";
import postman from "../assets/svg/tools/postman.png";
import git from "../assets/svg/tools/git.svg";
import clickUp from "../assets/svg/tools/clickup.svg";
import android from "../assets/svg/tools/android.png";
import figma from "../assets/svg/tools/figma.png";
import photoshop from "../assets/svg/tools/photoshop.png";
import illustrator from "../assets/svg/tools/illustrator.png";
import github from "../assets/svg/tools/github.png";
import gitlap from "../assets/svg/tools/gitlab.png";
import vercel from "../assets/svg/tools/vercel.png";

const tool = [
  {
    img: vscode,
    title: "Visual Code",
  },
  {
    img: itj,
    title: "Intellij Idea",
  },
  {
    img: git,
    title: "Git Version Control",
  },
  {
    img: android,
    title: "Android Studio",
  },
  {
    img: postman,
    title: "Postman",
  },
  {
    img: clickUp,
    title: "ClickUp",
  },
  {
    img: figma,
    title: "Figma UX/UI",
  },
  {
    img: photoshop,
    title: "Adobe Photoshop",
  },
  {
    img: illustrator,
    title: "Adobe Illustrator",
  },
  {
    img: github,
    title: "Github",
  },
  {
    img: gitlap,
    title: "Gitlap",
  },
  {
    img: vercel,
    title: "Vercel",
  },
];

export { tool };
